import React from 'react';
import { motion } from 'framer-motion';

export default function SystemLines() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-20">
      <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
        <motion.path
          d="M0,100 C150,100 200,300 400,300 C600,300 700,100 1000,100"
          fill="none"
          stroke="#FAF0E0"
          strokeWidth="1"
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{ pathLength: 1, opacity: 0.3 }}
          transition={{ duration: 3, ease: "easeInOut", repeat: Infinity, repeatType: "reverse" }}
        />
        <motion.path
          d="M200,0 L200,800"
          fill="none"
          stroke="#FAF0E0"
          strokeWidth="1"
          strokeDasharray="4 4"
          initial={{ y: -800 }}
          animate={{ y: 800 }}
          transition={{ duration: 15, ease: "linear", repeat: Infinity }}
        />
        <motion.path
          d="M800,0 L800,800"
          fill="none"
          stroke="#FAF0E0"
          strokeWidth="1"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 4, ease: "easeInOut", repeat: Infinity, repeatType: "reverse" }}
        />
        <motion.circle
          cx="400" cy="300" r="4"
          fill="#C94830"
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 0.8 }}
          transition={{ duration: 2, delay: 1, repeat: Infinity, repeatType: "reverse" }}
        />
        <motion.circle
          cx="200" cy="100" r="3"
          fill="#FAF0E0"
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.5 }}
          transition={{ duration: 2, repeat: Infinity, repeatType: "reverse" }}
        />
      </svg>
    </div>
  );
}